/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // Simple American to British English dictionary

  const localize = () => {
    let translate = {};

    const lookupList = window.theme.settings.internationalizationLookupList;

    lookupList.forEach(item => {
      const line = item.split(':');

      translate[line[0]] = line[1];
    });

    // Build regex for all words
    const regex = new RegExp("\\b(" + Object.keys(translate).join("|") + ")\\b", "gi");

    // Function to replace text in a node
    function replaceText(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = node.textContent.replace(regex, function(match) {
          // Preserve case
          const lower = match.toLowerCase();
          let replacement = translate[lower];
          if (!replacement) return match;
          if (match[0] === match[0].toUpperCase()) {
            replacement = replacement[0].toUpperCase() + replacement.slice(1);
          }
          return replacement;
        });
      } else if (
        node.nodeType === Node.ELEMENT_NODE &&
        node.nodeName !== "SCRIPT" &&
        node.nodeName !== "STYLE" &&
        node.nodeName !== "TEXTAREA"
      ) {
        for (let child of node.childNodes) {
          replaceText(child);
        }
      }
    }

    replaceText(document.body);
  }

  if(window.theme.settings.internationalizationCurrencies.includes(window.Shopify.currency.active)) {
    localize();

    if(theme.template == 'product') {
      setTimeout(() => {
        localize();
      }, 500);
    }
  }

  class RushPersonalization extends HTMLElement {
    constructor() {
      super();

      this.parentId = this.getAttribute('data-parent-id');
      this.parentSection = document.getElementById('shopify-section-'.concat(this.parentId));
      this.form = this.parentSection.querySelector('product-form');
      this.product = window.theme.rushProduct;
      this.checkbox = this.querySelector('input[type=checkbox]');
      
      document.addEventListener('theme:cart:add', (e) => {
        if(e.detail.button.form.querySelector('[name="section-id"]').value == this.parentId && this.checkbox.checked) {
          setTimeout(() => {
            this.addRushProductToCart();
          }, 500);
        }
      });

      this.addEventListener('change', (e) => {
        this.updateProductProperty(e.target.checked);
      });

      document.addEventListener('theme:cart:change', (e) => {
        setTimeout(() => {
          this.refreshRushProductInPDP();
        }, 500);
      });

      this.addRushProductToCart();
    }

    updateProductProperty (rush) {
      if( ! this.form) return;
      
      const rushPersoProperty = this.form.querySelector(`input[name="properties[Rush]"]`);
      
      if( ! rush) {
        if (rushPersoProperty) rushPersoProperty.remove();

        return;
      }

      if (rushPersoProperty) return;

      const rushProperty = document.createElement('input');

      rushProperty.setAttribute('type', 'hidden');
      rushProperty.setAttribute('name', `properties[Rush]`);
      rushProperty.setAttribute('value', 'Yes');

      this.form.querySelector('form').appendChild(rushProperty);
    }

    show() {
      this.setAttribute('data-open', 'true');
    }

    hide() {
      this.setAttribute('data-open', 'false');
    }

    async refreshRushProductInPDP () {
      // Get the items in the cart first and see if rush product is already in the cart
      const { items } = JSON.parse(document.querySelector('cart-items script[type="application/json"]')?.textContent) || [];

      this.checkbox.checked = false;

      this.updateProductProperty(false);

      if(items.length == 0) {
        return;
      }

      for (let item of items) {
        if (item.product_id == this.product.id) {
          this.checkbox.checked = true;
          this.updateProductProperty(true);

          return;
        }
      }
    }

    async addRushProductToCart (item) {
      // Get the items in the cart first and see if rush product is already in the cart
      const { items } = JSON.parse(document.querySelector('cart-items script[type="application/json"]')?.textContent) || [];

      if(item) items.push(item);

      let hasRushPersonalization = false,
          rushProductInCart = false;

      for (let item of items) {
        if (item.productId == this.product.id) {
          rushProductInCart = true;
        }

        if (item.properties && item.properties['Rush'] == 'Yes') {
          hasRushPersonalization = true;
        }
      }

      if ( ! hasRushPersonalization || rushProductInCart) return;

      fetch('/cart/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: this.product.variants[0].id,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { detail: data }));
      });
    }

    async removeRushProductFromCart () {
      // Get the items in the cart first and see if rush product is still in the cart
      // and if so, look for any products that have the rush personalization property
      // If no products have the rush personalization property, remove the rush product from the cart
      // and refresh the cart
      const rushProduct = window.theme.rushProduct,
            { items } = JSON.parse(document.querySelector('cart-items script[type="application/json"]')?.textContent) || [],
            productsWithRushProperty = [];

      let rushProductLineIndex = items.filter(item => item.productId == rushProduct.id)[0]?.line || null,
          rushProductInCart = rushProductLineIndex != null,
          rushProductInCartWithRushProperty = items.filter(item => item.isRush).length > 0;

      if(rushProductInCartWithRushProperty) {
        items.forEach((item) => {
          if (item.isRush) {
            const productProperties = {};
  
            for (const property in item.properties) {
              if (property !== 'Rush') {
                productProperties[property] = item.properties[property];
              }
            }
  
            productsWithRushProperty.push({
              quantity: item.quantity,
              properties: productProperties, 
              line: item.line
            });
          }
        });
      }

      // If the rush product is not in the cart, remove the rush personalization property from all
      // products in cart and exit
      if ( ! rushProductInCart) {
        for (const item in productsWithRushProperty) {
          await fetch(theme.routes.cart_change_url, {
            method: 'post',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({
              line: productsWithRushProperty[item].line,
              quantity: productsWithRushProperty[item].quantity,
              properties: productsWithRushProperty[item].properties
            }),
          })
          .then(response => response.json())
          .then(cart => {
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { detail: cart }));
          });
        }

        return;
      }

      // Exit if the rush product is in the cart and one product has the rush personalization property
      if (rushProductInCart && rushProductInCartWithRushProperty) {
        const cartRushProduct = items.filter(item => item.productId == rushProduct.id)[0];

        if(cartRushProduct.quantity > 1) {
          const data = {
            line: rushProductLineIndex,
            quantity: 1,
          };
          
          fetch(theme.routes.cart_change_url, {
            method: 'post',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify(data),
          })
            .then(response => response.json())
            .then(cart => {
              document.dispatchEvent(new CustomEvent('theme:cart:refresh', { detail: cart }));
            });
        }

        return;
      }

      const data = {
        line: rushProductLineIndex,
        quantity: 0,
      };

      this.updateProductProperty(false);

      fetch(theme.routes.cart_change_url, {
        method: 'post',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify(data),
      })
        .then(response => response.json())
        .then(cart => {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { detail: cart }));
        });

      return;
    }
  }

  customElements.define('rush-personalization', RushPersonalization);

  document.addEventListener('theme:cart:change', async (e) => {
    setTimeout(() => {
      RushPersonalization.prototype.removeRushProductFromCart();
    }, 1500);
  });
  
  document.addEventListener('click', function (e) {
    const target = e.target;
    const rushPersoBtn = document.getElementById('product__form__custom_input--rush-personalisation');
    
    if(target.parentElement.classList.contains('product-personalizer')) {
      const rushPersonalizationElement = document.querySelector('rush-personalization');

      if(target.classList.contains('pplr_remove')) {
        rushPersoBtn.style.display = 'none';
        rushPersoBtn.parentElement.setAttribute('data-open', false);

        rushPersonalizationElement.updateProductProperty(false);
      } else {
        rushPersoBtn.style.display = 'block';
        rushPersoBtn.parentElement.setAttribute('data-open', true);

        if(rushPersonalizationElement.checkbox.checked) {
          rushPersonalizationElement.updateProductProperty(true);
        }
      }
    }
  });

  // Move Rush Personalization element
  document.addEventListener("DOMContentLoaded", () => {
    // 1. Grab the existing rush-personalization element
    const rushEl = document.querySelector("rush-personalization");
    if (!rushEl) return;

    // 2. Find the product form
    const productForm = document.querySelector("product-form form");
    if (!productForm) return;

    // 3. Find product__submit inside the form
    const submitBlock = productForm.querySelector(".product__submit");
    if (!submitBlock) {
      console.warn("product__submit not found in product-form");
      return;
    }

    // 4. Move (not clone) rush-personalization right before product__submit
    submitBlock.parentNode.insertBefore(rushEl, submitBlock);

    // 5. Update RushPersonalization parent reference if needed
    //    Their script relies on data-parent-id matching the section wrapper.
    //    If the form is inside same section, this does nothing harmful.
    if (typeof RushPersonalization !== "undefined") {
      // Re-link parent ID after moving
      rushEl.dataset.parentId = productForm.closest("[id^='template--']")?.id || rushEl.dataset.parentId;
    }
  });

  /**
   * Custom cart tracking function for Zepto Product Personaliser
   * Is called when a product with personalisation is added to the cart
   * @param {Object} data - The data object from the event
   */
  window.pplr_custom_cart_track = async function(data) {
    const rushPersonalizationElement = document.querySelector('rush-personalization');
    await rushPersonalizationElement.addRushProductToCart(data);

    const klaviyoTrack = (data) => {
      var klAjax = true;
      var _learnq = window._learnq || [];
      var cart = {
        total_price: data.total_price / 100,
        $value: data.total_price / 100,
        total_discount: data.total_discount,
        original_total_price: data.original_total_price / 100,
        items: data.items
      }

      if (item !== 'undefined') {
        cart = Object.assign(cart, item)
      }

      if (klAjax) {
        _learnq.push(['track', 'Added to Cart', cart]);
        klAjax = false;
      }
    }

    //klaviyoTrack(data);
    const cartDrawer = document.querySelector('cart-drawer');

    if(cartDrawer) {
      cartDrawer.openCartDrawer();
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
        detail: {
          response: data,
          cartDrawer: cartDrawer
        },
        bubbles: true
      }));
    } else {
      window.location.reload();
      //window.location.href = '/cart';
    }
  }

  class CollectionLoadMore extends HTMLElement {
    constructor() {
      super();

      this.collectionComponent = this.closest('collection-component');
      this.loadMoreButton = this.querySelector('button');

      this.loadMoreButton.addEventListener('click', this.loadMore.bind(this));
    }

    loadMore() {
      if (this.loadMoreButton) {
        this.loadMoreButton.setAttribute('disabled', true);
        this.loadMoreButton.innerText = this.getAttribute('data-collection-load-more-loading-text');
      }

      const loadMoreUrl = this.getAttribute('data-collection-load-more-url');

      // Update the URL in the url bar
      if (history.pushState) {
        history.pushState(null, null, loadMoreUrl);
      }
      
      fetch(loadMoreUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newItems = doc.querySelectorAll('collection-component .product-item');

          newItems.forEach(item => {
            this.collectionComponent.querySelector('.grid').appendChild(item);
          });

          if (this.loadMoreButton) {
            this.loadMoreButton.removeAttribute('disabled');
            this.loadMoreButton.innerText = this.getAttribute('data-collection-load-more-text');
          }

          if (doc.querySelector('collection-load-more') == null) {
            this.remove();
          } else {
            this.setAttribute('data-collection-load-more-url', doc.querySelector('collection-load-more').getAttribute('data-collection-load-more-url'));
          }
        });
    }
  }

  customElements.define('collection-load-more', CollectionLoadMore);

  class ProductBundle extends HTMLElement {
    constructor() {
      super();
      this.bundleComponents = this.querySelectorAll('bundle-component');
      this.bundleForm = this.querySelector('form');
      this.rushPersonalization = this.querySelector('rush-personalization');

      this.bundleForm.addEventListener('submit', this.onSubmit.bind(this));
    }
    
    connectedCallback() {
      this.bundleComponents.forEach(bundleComponent => {
        const bundleProduct = JSON.parse(Array.from(bundleComponent.children).filter(child => child.type == 'application/json')[0].textContent),
              unavailableOptions = bundleProduct.variants.filter(variant => !variant.available).map(variant => variant.title);

        bundleComponent.querySelectorAll('[data-single-option-selector]').forEach(option => {
          // Set the options to disabled if the variant is not available
          if (unavailableOptions.includes(option.value)) {
            option.classList.add('sold-out');
            option.removeAttribute('checked');
            option.setAttribute('disabled', true);
          }
          
          option.addEventListener('click', (e) => {
            const variantId = bundleProduct.variants.find(variant => variant.title === e.target.value).id;

            bundleComponent.setAttribute('data-selected-variant-id', variantId);
            bundleComponent.querySelector('.radio__legend__value').innerText = e.target.value;
          });
        });
      });
    }

    onSubmit(e) {
      e.preventDefault();

      const components = this.querySelectorAll('bundle-component'),
            items = [],
            bundleAddId = Math.floor(100000 + Math.random() * 900000),
            cartDrawer = document.querySelector('cart-drawer');

      let formValid = true,
          cartHasRushProduct = false,
          bundleHasRush = false;
      
      cartDrawer.querySelectorAll('input[name="updates[]"]').forEach(input => {
        if(input.getAttribute('data-id').includes(window.theme.rushProduct.variants[0].id)) {
          cartHasRushProduct = true;
        }
      });

      components.forEach(component => {
        const personalizationComponent = component.querySelector('product-personalization'),
              variantId = component.dataset.selectedVariantId,
              itemProperties = {
                "__bundle": "true",
                "__bundleproduct": this.dataset.bundleHandle,
                "__bundleaddid": bundleAddId,
                "__bundleoriginalprice": this.dataset.originalPrice,
                "__bundlediscountedprice": this.dataset.discountedPrice
              };

        if(personalizationComponent && Object.keys(personalizationComponent.personalizationValues).length > 0) {
          if( ! personalizationComponent.validate()) {
            formValid = false;
            return;
          }

          Object.assign(itemProperties, personalizationComponent.personalizationValues);

          // Set default values for personalization
          itemProperties['Embroidery font'] = itemProperties['Embroidery font'] || 'Serif';
          itemProperties['Embroidery color'] = itemProperties['Embroidery color'] || 'Black';

          // Add rush property if rush checkbox is ticked
          if(this.rushPersonalization && this.rushPersonalization.checkbox.checked) {
            itemProperties["Rush"] = "Yes";
            bundleHasRush = true;
          }
        } 

        if (variantId) {
          items.push({
            id: variantId,
            quantity: 1,
            properties: itemProperties
          });
        }
      });

      if ( ! formValid) return;
      if (items.length === 0) return;

      items.reverse(); // Reverse the order of items to ensure the last item is added first

      // Add the rush product in the items to add
      // if at least one bundle component has rush
      // and the rush product isn't in the cart yet
      if(bundleHasRush && ! cartHasRushProduct) {
        items.push({
          id: window.theme.rushProduct.variants[0].id,
          quantity: 1
        });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: items})
      })
      .then(response => response.json())
      .then(data => {

        if(cartDrawer) {
          cartDrawer.openCartDrawer();
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
            detail: {
              response: data,
              cartDrawer: cartDrawer
            },
            bubbles: true
          }));
        } else {
          window.location.href = '/cart';
        }
      });
    }
  }

  customElements.define('product-bundle', ProductBundle);

  class BundleComponentsButton extends HTMLElement {
    constructor() {
      super();

      this.bundleAddId = this.dataset.bundleAddId;
      this.bundleComponents = document.querySelector(`cart-bundle-components[data-bundle-add-id="${this.bundleAddId}"]`);
      this.button = this.querySelector('button');

      this.button.addEventListener('click', this.showHideBundleComponents.bind(this));
    }

    showHideBundleComponents() {
      if (this.bundleComponents) {
        const isOpen = this.bundleComponents.dataset.open === 'true';

        if (isOpen) {
          this.bundleComponents.setAttribute('data-open', false);
          this.setAttribute('data-open', false);
        } else {
          this.bundleComponents.setAttribute('data-open', true);
          this.setAttribute('data-open', true);
        }
      }
    }
  }

  customElements.define('bundle-components-button', BundleComponentsButton);

  class BundleParent extends HTMLElement {
    constructor() {
      super();

      this.handlePrice();
    }

    handlePrice() {
      let bundlePrice = 
      this.nextElementSibling().children().forEach(bundleItem => {

      })
    }
  }

  class BundleComponentsRemoveButton extends HTMLElement {
    constructor() {
      super();

      this.bundleAddId = this.dataset.bundleAddId;
      this.bundleComponents = document.querySelector(`cart-bundle-components[data-bundle-add-id="${this.bundleAddId}"]`);
      this.button = this.querySelector('button');
      this.bundleParent = this.closest('bundle-parent');

      this.button.addEventListener('click', this.removeBundleComponents.bind(this));
    }

    async removeBundleComponents() {
      if ( ! this.bundleComponents) {
        return;
      }

      this.closest('cart-drawer').classList.add('is-loading');

      this.closest('cart-items').querySelectorAll(`[data-bundle-add-id="${ this.bundleAddId }"]`).forEach(item => {
        if(item.dataset.open === 'true') {
          item.setAttribute('data-open', false);
        }
      });

      const lineItemsToRemove = [];

      this.bundleComponents.querySelectorAll('.cart__item.cart__item--bundle').forEach(item => {
        lineItemsToRemove.push({
          line: parseInt(item.dataset.itemIndex),
          quantity: 0
        });
      });

      // Sort the line items to remove by line number in descending order
      lineItemsToRemove.sort((a, b) => b.line - a.line);

      for(const index in lineItemsToRemove) {
        this.bundleParent.classList.add('is-loading');

        await fetch(theme.routes.cart_change_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(lineItemsToRemove[index])
        });

        this.bundleParent.classList.add('is-removed');
      }

      const cartDrawer = document.querySelector('cart-drawer');

      if(cartDrawer) {
        cartDrawer.openCartDrawer();
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', {}));
      } else {
        window.location.href = '/cart';
      }
    }
  }

  customElements.define('bundle-components-remove-button', BundleComponentsRemoveButton);

  class ProductPersonalization extends HTMLElement {
    constructor() {
      super();

      this.personalizationValuesContainer = this.querySelector('script');
      this.personalizationValues = JSON.parse(this.personalizationValuesContainer.innerText);
      this.personalizationContainer = this.querySelector('.product__personalization-options');

      this.productPersonalizationButton = this.querySelector('[data-action=add-remove]');
      this.removePersonalizationButton = this.querySelector('[data-action=remove]');
      this.updatePersonalizationButton = this.querySelector('[data-action=update]');
      this.editPersonalizationButton = this.querySelector('[data-action=edit]');
      this.cancelChangesButton = this.querySelector('[data-action=cancel]');

      this.rushPersonalization = this.closest('product-component')?.querySelector('rush-personalization');
      
      if(this.productPersonalizationButton) {
        this.productPersonalizationButton.addEventListener('click', this.handleAddRemovePersonalization.bind(this));
      }

      if(this.removePersonalizationButton) {
        this.removePersonalizationButton.addEventListener('click', this.handleRemovePersonalization.bind(this));
      }

      if(this.updatePersonalizationButton) {
        this.updatePersonalizationButton.addEventListener('click', this.handleUpdatePersonalization.bind(this));
      }

      if(this.cancelChangesButton) {
        this.cancelChangesButton.addEventListener('click', this.handleCancelChanges.bind(this));
      }

      if(this.editPersonalizationButton) {
        this.editPersonalizationButton.addEventListener('click', this.handleEditPersonalization.bind(this));
      }

      this.querySelectorAll('input').forEach(input => {
        input.addEventListener('change', this.handleChange.bind(this));
      });

      this.querySelector('input[type="text"]').addEventListener('keyup', (e) => {
        // get the text input value length and update the character count
        const target = e.target,
              textInput = target.value,
              charCount = this.querySelector('.product__personalization-character-limit');
        
        charCount.innerText = window.theme.languages.product.personalization.character_limit.replace('{{ characters_left }}', parseInt(target.getAttribute('maxlength')) - textInput.length);
      });
    }

    handleCancelChanges(e) {
      e.preventDefault();
      
      fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
            detail: {
              response: data,
              cartDrawer: document.querySelector('cart-drawer')
            },
            bubbles: true
          }));
        });
    }

    handleEditPersonalization(e) {
      e.preventDefault();
      e.target.value = true;
      e.target.style.display = 'none';
      this.productPersonalizationButton = e.target;
      this.personalizationContainer.setAttribute('data-open', true);

      this.closest('.cart__item').setAttribute('data-personalization-open', true);
      this.previousElementSibling.style.display = 'none';

      if(this.removePersonalizationButton) {
        this.removePersonalizationButton.style.display = 'none';
      }
    }

    handleUpdatePersonalization(e) {
      e.preventDefault();
      
      if ( ! this.validate()) {
        return;
      }

      // Set default values for personalization
      if(Object.keys(this.personalizationValues).length > 0) {
        this.personalizationValues['Embroidery font'] = this.personalizationValues['Embroidery font'] || 'Serif';
        this.personalizationValues['Embroidery color'] = this.personalizationValues['Embroidery color'] || 'Black';
      }

      const body = JSON.stringify({
        line: this.closest('.cart__item').dataset.itemIndex,
        quantity: 1,
        properties: this.personalizationValues
      });

      fetch(theme.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: body
      })
      .then(response => response.json())
      .then(data => {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
          detail: {
            response: data,
            cartDrawer: document.querySelector('cart-drawer')
          },
          bubbles: true
        }));
      });
    }

    handleRemovePersonalization(e) {
      e.preventDefault();

      const thisButton = e.target;
      this.personalizationContainer.setAttribute('data-open', false);

      const availableOptions = this.dataset.options ? this.dataset.options.split(',') : [],
            properties = {};
            
      // Create a new properties object excluding the personalization values
      Object.keys(this.personalizationValues).forEach(key => {
        if ( ! availableOptions.includes(key)) {
          properties[key] = this.personalizationValues[key];
        }
      });

      const body = JSON.stringify({
        line: this.closest('.cart__item').dataset.itemIndex,
        quantity: 1,
        properties: properties
      });

      fetch(theme.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: body
      })
      .then(response => response.json())
      .then(data => {
        return data;

        document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
          detail: {
            response: data,
            cartDrawer: document.querySelector('cart-drawer')
          },
          bubbles: true
        }));
      });

      this.personalizationValues = properties;
      this.personalizationValuesContainer.innerText = JSON.stringify(properties); // Reset personalization values
      this.resetFields();

      this.previousElementSibling.style.display = 'none';
      thisButton.style.display = 'none';
    }

    handleAddRemovePersonalization(e) {
      e.preventDefault();

      const thisButton = e.target;

      if (thisButton.value === 'false') {
        thisButton.value = true;
        this.personalizationContainer.setAttribute('data-open', true);

        thisButton.innerText = window.theme.languages.product.personalization.remove;

        if (this.dataset.isLineItem === 'true') {
          thisButton.innerText = window.theme.languages.product.personalization.update;

          this.closest('.cart__item').setAttribute('data-personalization-open', true);
          this.previousElementSibling.style.display = 'none';
        }

        if (this.rushPersonalization) {
          this.rushPersonalization.show();
        }
      } else {
        this.personalizationValuesContainer.inertText = JSON.stringify({}); // Reset personalization values
        this.personalizationValues = {};
        thisButton.value = false;
        this.personalizationContainer.setAttribute('data-open', false);
        thisButton.innerText = window.theme.languages.product.personalization.add;
        
        if (this.dataset.isLineItem === 'true') {
          thisButton.innerText = window.theme.languages.product.personalization.edit;

          this.closest('.cart__item').setAttribute('data-personalization-open', false);
          this.previousElementSibling.style.display = 'block';
        } else {
          // Only reset inputs if this is not a line item
          this.resetFields();
        }
        
        if (this.rushPersonalization) {
          if (this.closest('product-bundle')) {
            // Only hide the rush personalization if there are no personalizations in the product
            if (Array.from(this.closest('product-bundle').querySelectorAll('[data-action=add-remove]')).filter(button => button.value == 'true').length == 0) {
              this.rushPersonalization.hide();
            }
          } else {
            this.rushPersonalization.hide();
          }
        }
      }
    }

    handleChange(e) {
      const target = e.target;

      this.personalizationValues[target.dataset.optionName] = target.value;

      if(target.dataset.optionName.includes('font')) {
        this.querySelectorAll('.product__personalization-text').forEach(inputContainer => {
          inputContainer.classList.remove('script', 'serif');
          inputContainer.classList.add(target.value.toLowerCase());
        });
      }
    }

    resetFields() {
      this.querySelectorAll('input').forEach(input => {
        input.checked = false;

        if(input.type === 'text') {
          input.value = '';
        }

        if(input.dataset.index == 1) {
          input.checked = true; // Ensure the first option is checked by default
        }
      });
    }

    validate() {
      if(this.productPersonalizationButton.value === 'false') {
        return true; // No personalization selected, validation passes
      }
      
      let isValid = true;

      // Check if all required inputs are filled
      const textInputs = this.querySelectorAll('input[type="text"]');

      textInputs.forEach(input => {
        input.nextElementSibling.classList.remove('is-visible');
        input.nextElementSibling.innerHTML = '';

        if(input.value === '') {
          input.focus();
          input.nextElementSibling.innerHTML = `<div class="errors"><ul><li>${ window.theme.languages.product.personalization.error }</li></ul></div>`;
          input.nextElementSibling.classList.add('is-visible');
          isValid = false;
        };
      });

      return isValid;
    }
  }

  customElements.define('product-personalization', ProductPersonalization);
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
